import * as React from "react";
import styled from "@mui/material/styles/styled";
import { useTranslate } from "../../hooks/useTranslate";
import { PatientColorMap } from "../../layout/patientColorMap";
import { ReactComponent as NoMatchingResultsIcon } from "../../assets/noMatchingResultsIcon.svg";
import { marginLeftToMarginRightOnRtl } from "fe-web-components/rtl/rtlStyles";

//region [[ Styles ]]

const NoMatchingResultsDisclaimerView = styled("div")(({ theme }) => ({
  position: "relative",
  margin: "18px 18px 18px",
  padding: "18px",
  border: `2px solid ${PatientColorMap.Background}`,
  borderRadius: "5px",
  color: PatientColorMap.Primary,
  fontSize: "16px",
}));

const NoMatchingIcon = styled(NoMatchingResultsIcon)(({ theme }) => ({
  position: "absolute",
  "& path": {
    fill: PatientColorMap.Primary,
  },
  top: "-15px",
  ...marginLeftToMarginRightOnRtl(-15),
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface NoMatchingResultsDisclaimerProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const NoMatchingResultsDisclaimer = ({
  ...props
}: NoMatchingResultsDisclaimerProps) => {
  const { translate } = useTranslate();

  return (
    <NoMatchingResultsDisclaimerView>
      <NoMatchingIcon></NoMatchingIcon>
      {translate("NO_MATCHING_DD")}
    </NoMatchingResultsDisclaimerView>
  );
};
